// extracted by mini-css-extract-plugin
export var clickableWrapper = "_22-2";
export var placeholderIcon = "_22-3";
export var thumbnailCanvas = "_22-1";
export var thumbnailWrapper = "_22-0";